import { render } from "./PyxisDemo.vue?vue&type=template&id=34ac7da4"
import script from "./PyxisDemo.vue?vue&type=script&lang=js"
export * from "./PyxisDemo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__